module.exports = __webpack_public_path__ + "img/kr-red-card-right-bottom-2.5b74f2c.png";